module.exports = __webpack_public_path__ + "media/9.841faf80.mp3";